import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/widgets/header";
import { Footer } from "@/widgets/footer";
import { SubscriptionContent } from "@/features/subscription";

/**
 * SubscriptionPage - Wrapper 컴포넌트
 * 레이아웃과 라우팅만 담당
 * 콘텐츠는 features/subscription에서 관리
 */
export function SubscriptionPage() {
  const location = useLocation();

  // /subscription/checkout 경로면 CheckoutPage 렌더링
  if (location.pathname === "/subscription/checkout") {
    return <Outlet />;
  }

  return (
    <div className="w-full flex flex-col bg-white">
      {/* Main Content */}
      <SubscriptionContent />
    </div>
  );
}
